import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule2 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE2: TIdToPageConfigMap = {
  [PageIdStylioCapsule2.AGE_CAPSULE2]: {
    id: PageIdStylioCapsule2.AGE_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapsule2.URGE_CAPSULE2]: {
    id: PageIdStylioCapsule2.URGE_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.HAIR_COLOR_CAPSULE2]: {
    id: PageIdStylioCapsule2.HAIR_COLOR_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.EYES_COLOR_CAPSULE2]: {
    id: PageIdStylioCapsule2.EYES_COLOR_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.JEWELRY_CAPSULE2]: {
    id: PageIdStylioCapsule2.JEWELRY_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.BODY_SHAPE_CAPSULE2]: {
    id: PageIdStylioCapsule2.BODY_SHAPE_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.STYLIO_TO_HELP_CAPSULE2]: {
    id: PageIdStylioCapsule2.STYLIO_TO_HELP_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.TALL_CAPSULE2]: {
    id: PageIdStylioCapsule2.TALL_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.WEIGHT_CAPSULE2]: {
    id: PageIdStylioCapsule2.WEIGHT_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.URGE_2_CAPSULE2]: {
    id: PageIdStylioCapsule2.URGE_2_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.FEEL_ABOUT_CAPSULE2]: {
    id: PageIdStylioCapsule2.FEEL_ABOUT_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.PERCENTAGE_CAPSULE2]: {
    id: PageIdStylioCapsule2.PERCENTAGE_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.SHOPPING_CAPSULE2]: {
    id: PageIdStylioCapsule2.SHOPPING_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.STYLE_MOST_MATTERS_CAPSULE2]: {
    id: PageIdStylioCapsule2.STYLE_MOST_MATTERS_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.FAVORITE_COLORS_CAPSULE2]: {
    id: PageIdStylioCapsule2.FAVORITE_COLORS_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_11_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_11_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_12_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_12_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_13_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_13_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_14_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_14_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_15_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_15_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_16_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_16_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_17_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_17_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_18_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_18_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.LIKE_OR_DISLIKE_19_CAPSULE2]: {
    id: PageIdStylioCapsule2.LIKE_OR_DISLIKE_19_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.STYLES_FEEL_LIKE_YOU_CAPSULE2]: {
    id: PageIdStylioCapsule2.STYLES_FEEL_LIKE_YOU_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.URGE_4_CAPSULE2]: {
    id: PageIdStylioCapsule2.URGE_4_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.BRAND_CAPSULE2]: {
    id: PageIdStylioCapsule2.BRAND_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.FIND_NEW_CLOTHES_CAPSULE2]: {
    id: PageIdStylioCapsule2.FIND_NEW_CLOTHES_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.NOTHING_TO_WEAR_CAPSULE2]: {
    id: PageIdStylioCapsule2.NOTHING_TO_WEAR_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.OLD_CLOTHES_CAPSULE2]: {
    id: PageIdStylioCapsule2.OLD_CLOTHES_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.COMBINE_CLOTHES_CAPSULE2]: {
    id: PageIdStylioCapsule2.COMBINE_CLOTHES_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.OPTIMIZE_BUDGET_CAPSULE2]: {
    id: PageIdStylioCapsule2.OPTIMIZE_BUDGET_CAPSULE2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule2.URGE_3_CAPSULE2]: {
    id: PageIdStylioCapsule2.URGE_3_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.PREPARE_FLOW_CAPSULE2]: {
    id: PageIdStylioCapsule2.PREPARE_FLOW_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.EMAIL_CAPSULE2]: {
    id: PageIdStylioCapsule2.EMAIL_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.EMAIL_CONSENT_CAPSULE2]: {
    id: PageIdStylioCapsule2.EMAIL_CONSENT_CAPSULE2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule2.SUBSCRIPTIONS_CAPSULE2]: {
    id: PageIdStylioCapsule2.SUBSCRIPTIONS_CAPSULE2,
  },
  [PageIdStylioCapsule2.CANCEL_OFFER_CAPSULE2]: {
    id: PageIdStylioCapsule2.CANCEL_OFFER_CAPSULE2,
  },
  [PageIdStylioCapsule2.SUB_UPSELL_CAPSULE2]: {
    id: PageIdStylioCapsule2.SUB_UPSELL_CAPSULE2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule2.UPSELL_CAPSULE2]: {
    id: PageIdStylioCapsule2.UPSELL_CAPSULE2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule2.DOWNLOAD_CAPSULE2]: {
    id: PageIdStylioCapsule2.DOWNLOAD_CAPSULE2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
